import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, Loader2, Eye } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/admin/PageHeader";
import { Button } from "@/components/ui/button";
import { formatDate } from "@/lib/format";
import { toast } from "sonner";

export default function AdminBlog() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/blog").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const del = async (id) => { await api.delete(`/admin/blog/${id}`); toast.success("Deleted"); load(); };

  return (
    <div>
      <PageHeader title="Blog & news" subtitle="Manage your property guides and articles"
        action={<Link to="/admin/blog/new"><Button className="rounded-full bg-[#C81D35] hover:bg-[#a5162b] gap-2" data-testid="add-post-btn"><Plus className="w-4 h-4" /> New post</Button></Link>} />
      <div className="bg-white rounded-xl border border-border overflow-hidden">
        {items === null ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-[#C81D35] animate-spin" /></div>
          : items.length === 0 ? <div className="text-center py-16 text-muted-foreground" data-testid="blog-empty">No posts yet.</div>
          : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-muted-foreground border-b border-border"><th className="p-4 font-medium">Title</th><th className="p-4 font-medium">Category</th><th className="p-4 font-medium">State</th><th className="p-4 font-medium">Date</th><th className="p-4"></th></tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} className="border-b border-border/60 last:border-0 hover:bg-muted/30" data-testid={`post-row-${p.id}`}>
                  <td className="p-4 font-medium text-[#111827]">{p.title}</td>
                  <td className="p-4 text-muted-foreground">{p.category}</td>
                  <td className="p-4"><span className={`text-xs px-2 py-1 rounded-full ${p.state === "published" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>{p.state}</span></td>
                  <td className="p-4 text-muted-foreground">{formatDate(p.published_at || p.created_at)}</td>
                  <td className="p-4 text-right whitespace-nowrap">
                    {p.slug && <Link to={`/blog/${p.slug}`} target="_blank"><Button variant="ghost" size="icon"><Eye className="w-4 h-4" /></Button></Link>}
                    <Link to={`/admin/blog/${p.id}`}><Button variant="ghost" size="icon" data-testid={`edit-post-${p.id}`}><Pencil className="w-4 h-4" /></Button></Link>
                    <Button variant="ghost" size="icon" className="text-red-600" onClick={() => del(p.id)}><Trash2 className="w-4 h-4" /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
